import * as React from 'react';
import { Link } from 'react-scroll';

import { logEvent } from '@api/analytics';
import {
  createStyles,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core';
import {
  FaceRounded,
  HomeRounded,
  HotelRounded,
  MapRounded,
  SecurityRounded
} from '@material-ui/icons';
import { useTheme } from '@material-ui/styles';

const styles = (theme: Theme) =>
  createStyles({
    drawer: {
      alignContent: 'end',
      width: theme.spacing(30),
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(7)
      }
    },
    drawerPaper: {
      width: theme.spacing(30),
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(7)
      }
    },
    listText: {
      lineHeight: '1.7em',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    active: {
      fontWeight: 'bold'
    },
    toolbar: theme.mixins.toolbar
  });

type IProps = WithStyles<typeof styles> & { disabled?: boolean };

export enum NavigationDrawerItems {
  HOUSING = 'housing',
  MARKET_PROFILE = 'market',
  SHORT_TERM_RENTALS = 'shortTerm',
  // SCHOOLS = 'schools',
  SAFETY = 'safety'
}

const drawerItems = [
  {
    title: 'Housing',
    icon: <HomeRounded />,
    to: NavigationDrawerItems.HOUSING
  },
  {
    title: 'Market Profile',
    icon: <FaceRounded />,
    to: NavigationDrawerItems.MARKET_PROFILE
  },
  {
    title: 'Short Term Rentals',
    icon: <HotelRounded />,
    to: NavigationDrawerItems.SHORT_TERM_RENTALS
  },
  // {
  //   title: 'Schools',
  //   icon: <SchoolRounded />,
  //   to: NavigationDrawerItems.SCHOOLS
  // },
  {
    title: 'Safety',
    icon: <SecurityRounded />,
    to: NavigationDrawerItems.SAFETY
  }
];

const NavigationDrawer: React.FC<IProps> = ({ classes, disabled }) => {
  const theme = useTheme<Theme>();
  const [active, setActive] = React.useState<string | null>(null);

  const linkProps = {
    offset: -theme.spacing(10),
    spy: true,
    smooth: true,
    duration: 500,
    onSetActive: (to: string) => {
      setActive(to);
      logEvent({
        category: 'Lieuucation',
        action: `Scrolled to ${to}`
      });
    },
    onSetInactive: () => setActive(null),
    activeClass: classes.active
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      anchor="right"
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div className={classes.toolbar} />
      <List>
        <Link to={disabled ? 'disabled' : 'execSummary'} {...linkProps}>
          <ListItem
            disabled={disabled}
            selected={'execSummary' === active}
            button
            key={'Executive Summary'}
          >
            <ListItemIcon>
              <MapRounded />
            </ListItemIcon>
            <ListItemText
              className={classes.listText}
              primaryTypographyProps={{ variant: 'inherit' }}
              primary={'Executive Summary'}
            />
          </ListItem>
        </Link>
      </List>
      <Divider />
      <List>
        {drawerItems.map((e) => (
          <Link key={e.to} to={disabled ? 'disabled' : e.to} {...linkProps}>
            <ListItem
              disabled={disabled}
              selected={e.to === active}
              button
              key={e.title}
            >
              <ListItemIcon>{e.icon}</ListItemIcon>
              <ListItemText
                className={classes.listText}
                primaryTypographyProps={{ variant: 'inherit' }}
                primary={e.title}
              />
            </ListItem>
          </Link>
        ))}
      </List>
    </Drawer>
  );
};

export default withStyles(styles)(NavigationDrawer);
